import clsx from "clsx";

const Button = ({
  text = "Submit",
  onClick,
  loading = false,
  disabled = false,
  variant = "primary", // Default variant
  className = "",
}) => {
  // Define variant classes
  const variantClasses = {
    primary: "bg-brand border-brand text-white",
    secondary: "bg-state-warning-solid border-state-warning-solid text-white",
    light: "bg-ui-surface-sunken border-ui-border text-ui-text-muted",
    custom: "", // Fully controlled via className
  };

  return (
    <button
      className={clsx(
        "flex items-center justify-center text-xs font-medium border-2 rounded-md cursor-pointer relative py-1 px-2",
        "disabled:bg-ui-text-subtle disabled:border-ui-text-subtle disabled:text-ui-border disabled:cursor-not-allowed",
        variant !== "custom" ? variantClasses[variant] : "",
        className // Custom classes fully override defaults
      )}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mx-2.5"></div>
      ) : (
        text
      )}
    </button>
  );
};

export default Button;
